import * as React from 'react';
import styled from 'styled-components';

const MainBottom = styled.div`
  width: 100%;
  background-color: #f2f3f1;
  padding: 5px 0;
  line-height: 0;
  text-align: center;
   & .inbox {
    width: 1000px;
    margin: 0 auto;
    display: -moz-box;
    display: -ms-box;
    display: -webkit-flexbox;
    display: -moz-flexbox;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
  }
  & .logo {
    width: 467px;
  }
  & .bana {
    width: 492px;
    display: inline-block;
    border-left: 1px solid #d7d1ce;
    padding: 3px 0 3px 5px;
  }
  & .bana li {
    width: 160px;
    float: left;
    margin-left: 2px;
    margin-bottom: 2px;
    line-height: 0;
  }
  & .bana li:first-child, .bana li:nth-child(4n) {
    margin-left: 0;
    background-color: #000;
  }
  & .bana li:nth-child(4n) {
    clear: both;
  }
  & img.banner {
    width: 160px;
    height: 40px;
  }
`;
const Copy = styled.div `
width: 100%;
background: #005daa -webkit-gradient(linear, left top, left bottom, color-stop(0.88, #005daa), color-stop(0, #004a88));
background: #005daa -webkit-linear-gradient(top, #004a88 0%, #005daa 88%);
background: #005daa -moz-linear-gradient(top, #004a88 0%, #005daa 88%);
background: #005daa -o-linear-gradient(top, #004a88 0%, #005daa 88%);
background: #005daa -ms-linear-gradient(top, #004a88 0%, #005daa 88%);
background: #005daa linear-gradient(to bottom, #004a88 0%, #005daa 88%);
padding: 5px 0;
& .copyright {
    color: #dddddd;
    font-size: 0.5em;
  }
`
const FMenu = styled.div `
width: 1200px;
margin: 0 auto 3px auto;
text-align: center;
color: #d2e1f7;
font-size: 7pt;
padding-bottom: 3px;
border-bottom: 1px solid #4daeff;
& a {
    color: #d2e1f7;
    text-decoration: none;
    & :hover {
        text-decoration: underline;
      }
  }
`
const Footer = () => (
  <footer>
    {/* 2750地区　エンブレム */}
    <MainBottom >
      <div className="inbox">
        <div className="logo">
          <img src="/images/banner-with-title.gif" width="451" height="100" alt="" />
        </div>
        <ul className="bana clearfix">
          <li>
            <a href="https://www.rotary.org/ja/" target="_blank">
              <img src="/images/banners/1.jpg" className="banner" alt="" />
            </a>
          </li>
          <li>
            <a href="https://rid2750.org/" target="_blank">
              <img src="/images/banners/2.jpg" className="banner" alt="" />
            </a>
          </li>
          <li>
            <a href="http://rotary-no-tomo.jp" target="_blank">
              <img src="/images/banners/3.jpg" className="banner" alt="" />
            </a>
          </li>
          <li>
            <a href="http://blog.livedoor.jp/chuoshin/" target="_blank">
              <img src="/images/banners/4.jpg" className="banner" alt="" />
            </a>
          </li>
          <li>
            <a href="/club/rotaract.html" target="_blank">
              <img src="/images/banners/5.jpg" className="banner" alt="" />
            </a>
          </li>
          <li>
            <a href="http://www.rotary-yoneyama.or.jp/" target="_blank">
              <img src="/images/banners/6.jpg" className="banner" alt="" />
            </a>
          </li>
        </ul>
      </div>
    </MainBottom>
    {/* 2750地区　エンブレム END */}

    {/* フッタ */}
    <Copy >
      {/* フッターメニュ */}
      <FMenu>
        ｜<a href="/">ホーム</a>│ <a href="/club">クラブ概要</a>│{' '}
        <a href="/volunteer">奉仕活動</a>│ <a href="/members">会員募集</a>│{' '}
        <a href="mailto:jimukyoku@tokyochuo-rotary.org?subject=お問い合わせ">
          お問い合わせ
        </a>
        │<a href="/speeches">卓話ライブラリー</a>│{' '}
        <a href="/makeup"> メークアップ</a>│{' '}
        <a href="http://www.rid2750.org/" target="_blank">
          ガバナー月信リンク
        </a>
        │ <a href="/sitemap">サイトマップ</a>｜
        <a href="/privacy">個人情報保護方針</a>｜
      </FMenu>
      {/* フッターメニュー END */}
      <span className="copyright">© 2021 The Rotary Club of Tokyo Chuo.</span>
    </Copy>
    {/* フッター END */}
  </footer>
);

export default Footer;
